import { useState } from "react";
import UserRoleList from "./UserRolesList"
import classes from "./style.module.scss";
import SearchBox from "../../component/SearchBox";

const ManageUserRoles = () => {
    const [searchInput, setSearchInput] = useState('')

    const handleChange = (value) => {
        setSearchInput(value)
    }

    return (
        <>
            <div className={`${classes.manageUserWrapper}`}>
                <div className={`w-[100%] flex items-center justify-between`}>
                    <div className={`layout-title`}>Manage User Roles</div>
                    <div className='flex items-center'>
                        <SearchBox className={''} value={searchInput} onChange={handleChange} placeholder={'Find by name, email, mobile...'} />
                    </div>
                </div>
                <div>
                    <UserRoleList searchInput={searchInput} />
                </div>
            </div>


        </>
    )
}

export default ManageUserRoles

